import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import FieldAgentLayout from './FieldAgentLayout';
import Scanner from './Scanner';
import VehicleList from './VehicleList';
import RecentActivity from './RecentActivity';
import VehicleDetail from './VehicleDetail';
import Maintenance from './Maintenance';

const FieldAgent: React.FC = () => {
  return (
    <Routes>
      <Route element={<FieldAgentLayout />}>
        <Route path="/" element={<Navigate to="/field-agent/scanner" replace />} />
        <Route path="/scanner" element={<Scanner />} />
        <Route path="/vehicles" element={<VehicleList />} />
        <Route path="/vehicles/:id" element={<VehicleDetail />} />
        <Route path="/activity" element={<RecentActivity />} />
        <Route path="/maintenance" element={<Maintenance />} />
      </Route>
    </Routes>
  );
};

export default FieldAgent;

